import { render, staticRenderFns } from "./VAppErrorOverlay.vue?vue&type=template&id=9a210844"
import script from "./VAppErrorOverlay.vue?vue&type=script&lang=js"
export * from "./VAppErrorOverlay.vue?vue&type=script&lang=js"
import style0 from "./VAppErrorOverlay.vue?vue&type=style&index=0&id=9a210844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports